import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Menu, Modal} from 'antd';
import {useTranslation} from "react-i18next";
import {useModal} from "../../../core/context/ModalContext";
import ApiService from "../../../core/service/api-service";
import WorklistItemCreateEdit from "../WorklistItemCreateEdit";
import WorklistItemSchedule from "../WorklistItemSchedule";
import {useDataGrid} from '../../../core/components/data-grid/DataGridContext';
import {ExclamationCircleOutlined} from '@ant-design/icons';
import {PERMISSIONS, useUser} from "../../../core/context/UserContext";

const {confirm} = Modal;

export default function WorklistItemRowMenu({row})
{
    const {t} = useTranslation();
    const {openModal, closeModal} = useModal();
    const {refreshDataGrid} = useDataGrid();
    const {hasPermission} = useUser();
    
    
    const handleDelete = () => {
        confirm({
            title: t('Are you sure you want to delete this worklist item?'),
            icon: <ExclamationCircleOutlined />,
            content: t('This action cannot be undone.'),
            okText: t('Yes'),
            okType: 'danger',
            cancelText: t('No'),
            async onOk() {
                const response = await ApiService.WorklistItem.Delete(row.id);
                if(response.success) {
                    refreshDataGrid();
                }
            },
        });
    }
    
    return (
        <>
            <RowMenu text={row.id}>
                <Menu>
                    {hasPermission(PERMISSIONS.WORKLIST_DELETE) && (
                        <Menu.Item key={'worklist-item-delete'} onClick={handleDelete}>
                            <div style={{color: 'red'}}>
                                {t('Delete')}
                            </div>
                        </Menu.Item>
                    )}
                </Menu>
            </RowMenu>
        </>
    )
}
